"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[164],{

/***/ 8445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ FooterNav; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8527);



var FooterNav = function(param) {
    var colorScheme = param.colorScheme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
        gap: 3,
        justifyContent: "center",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/",
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
                    variant: "nav",
                    color: colorScheme,
                    children: "\xa9 Joyline"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                w: "2px",
                height: "16px",
                bgColor: colorScheme,
                opacity: ".2"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/support",
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
                    variant: "nav",
                    color: colorScheme,
                    children: "Support"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                w: "2px",
                height: "16px",
                bgColor: colorScheme,
                opacity: ".2"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/privacy",
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
                    variant: "nav",
                    color: colorScheme,
                    children: "Privacy"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                w: "2px",
                height: "16px",
                bgColor: colorScheme,
                opacity: ".2"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/terms",
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
                    variant: "nav",
                    color: colorScheme,
                    children: "Terms"
                })
            })
        ]
    });
};


/***/ }),

/***/ 7510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ Logo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);


var Logo = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        src: "/images/logo.svg",
        width: 140,
        height: 36,
        alt: "Joyline"
    });
};


/***/ }),

/***/ 6299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ PageLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8527);


var PageLayout = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
            w: "full",
            minHeight: "100vh",
            bgGradient: "linear(to-br, #E9FEF4, #FEFCEA, #F8F0F0)",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: children
            })
        })
    });
};


/***/ }),

/***/ 6940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ RadioCard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9680);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8527);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9762);




var RadioCard = function(props) {
    var ref = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .useRadio */ .xL)(props), getInputProps = ref.getInputProps, getCheckboxProps = ref.getCheckboxProps;
    var input = getInputProps();
    var checkbox = getCheckboxProps();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        as: "label",
        cursor: "pointer",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, input)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, checkbox), {
                pointerEvents: "none",
                borderWidth: "1px",
                borderRadius: "md",
                p: "4",
                bgColor: "lighter-gray",
                borderColor: "light-gray",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                _checked: {
                    bgColor: "light-green",
                    color: "gray",
                    borderColor: "green"
                },
                _focus: {
                    boxShadow: "outline"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                        gap: 2,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Radio */ .Y8, {
                                isChecked: input.checked
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .FormLabel */ .lX, {
                                htmlFor: input.id,
                                m: 0,
                                children: props.label
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                        children: props.info
                    })
                ]
            }))
        ]
    });
};


/***/ }),

/***/ 5444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ SectionCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8527);


var SectionCard = function(param) {
    var title = param.title, titleCentered = param.titleCentered, iconSlot = param.iconSlot, descriptionSlot = param.descriptionSlot, actionSlot = param.actionSlot, footerSlot = param.footerSlot, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Stack */ .Kq, {
        as: "section",
        p: {
            base: 4,
            lg: 8
        },
        spacing: 8,
        bgColor: "white",
        borderRadius: "xl",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Stack */ .Kq, {
                    spacing: 4,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                            as: "header",
                            justifyContent: titleCentered ? "center" : "space-between",
                            alignItems: "center",
                            gap: 4,
                            flexDir: {
                                base: "column",
                                sm: "row"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                    alignItems: "center",
                                    gap: 4,
                                    children: [
                                        iconSlot,
                                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6, {
                                            as: "h1",
                                            size: "h1",
                                            children: title
                                        })
                                    ]
                                }),
                                actionSlot
                            ]
                        }),
                        descriptionSlot && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                            children: descriptionSlot
                        })
                    ]
                })
            }),
            children,
            footerSlot && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                as: "footer",
                children: footerSlot
            })
        ]
    });
};


/***/ }),

/***/ 1568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ SectionGroup; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8527);


var SectionGroup = function(param) {
    var title = param.title, actionSlot = param.actionSlot, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
        borderRadius: "lg",
        border: "2px",
        borderColor: "light-blue",
        p: {
            base: 4,
            lg: 8
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Stack */ .Kq, {
            spacing: 8,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6, {
                        as: "h2",
                        size: "h3",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                        children: children
                    }),
                    actionSlot && actionSlot
                ]
            })
        })
    });
};


/***/ }),

/***/ 9425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ Seo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);


var description = "Subscribe today and send some joy to your loved ones every month. Joyline will print and send your favorite pictures to the people in your life who prefer print over a screen.";
var Seo = function(param) {
    var _title = param.title, title = _title === void 0 ? "Joyline | Send printed photos" : _title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: title,
        description: description,
        canonical: "https://www.joyline.io/",
        openGraph: {
            url: "https://www.joyline.io/",
            title: "Send printed photos to loved ones monthly with Joyline.io",
            description: description,
            images: [
                {
                    url: "https://www.joyline.io/images/og/1200x630.png",
                    width: 1200,
                    height: 630,
                    alt: "Happy seniors, thanks to Joyline",
                    type: "image/jpeg"
                },
                {
                    url: "https://www.joyline.io/images/og/1200x600.png",
                    width: 1200,
                    height: 600,
                    alt: "Happy seniors, thanks to Joyline",
                    type: "image/jpeg"
                }, 
            ],
            site_name: "Joyline.io"
        },
        twitter: {
            handle: "@joyline_io",
            site: "@joyline_io",
            cardType: "summary_large_image"
        }
    });
};


/***/ }),

/***/ 7051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ StripePaymentMethod; }
});

// UNUSED EXPORTS: CardInput

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var index_esm = __webpack_require__(155);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(8527);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/chakra-ui-icon.esm.js
var chakra_ui_icon_esm = __webpack_require__(894);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chakra-ui-button.esm.js
var chakra_ui_button_esm = __webpack_require__(5193);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/toast/dist/chakra-ui-toast.esm.js
var chakra_ui_toast_esm = __webpack_require__(6933);
// EXTERNAL MODULE: ./node_modules/@stripe/react-stripe-js/dist/react-stripe.umd.js
var react_stripe_umd = __webpack_require__(6664);
// EXTERNAL MODULE: ./node_modules/@stripe/stripe-js/dist/stripe.esm.js
var stripe_esm = __webpack_require__(4465);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(9583);
;// CONCATENATED MODULE: ./src/features/settings/utils.ts

var getCardIcon = function(cardBrand) {
    return ({
        unknown: fa_index_esm/* FaRegCreditCard */._02,
        amex: fa_index_esm/* FaCcAmex */.ePy,
        diners: fa_index_esm/* FaCcDinersClub */.xKW,
        discover: fa_index_esm/* FaCcDiscover */.kLK,
        jcb: fa_index_esm/* FaCcJcb */.zuQ,
        mastercard: fa_index_esm/* FaCcMastercard */.leg,
        unionpay: fa_index_esm/* FaRegCreditCard */._02,
        visa: fa_index_esm/* FaCcVisa */.Z7w
    })[cardBrand];
};

;// CONCATENATED MODULE: ./src/components/stripe-payment-method.tsx










if (false) {}
var stripePromise = (0,stripe_esm/* loadStripe */.J)("pk_live_51LKYRyEnMzbvk2C2awEBxBzsp9hqzFk5sCbBekpwfhHZrygtDb5qib8Nma7Hi4wNhFYnTjN3q7KIVNuoW25XT9Hu00q4QksKF7");
var StripePaymentMethod = function(param) {
    var loading = param.loading, paymentMethod = param.paymentMethod, cardDeclined = param.cardDeclined, onAddPaymentMethod = param.onAddPaymentMethod, onRemovePaymentMethod = param.onRemovePaymentMethod;
    var ref, ref1, ref2;
    var ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.Elements, {
        stripe: stripePromise,
        children: paymentMethod ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
            justifyContent: "space-between",
            alignItems: "center",
            p: 4,
            border: "1px",
            borderColor: "light-gray",
            borderRadius: "md",
            gap: 4,
            flexDir: {
                base: "column",
                sm: "row"
            },
            color: cardDeclined ? "red" : "inherit",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                    gap: 2,
                    alignItems: "center",
                    flexDir: {
                        base: "column",
                        sm: "row"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icon_esm/* Icon */.JO, {
                            as: cardDeclined ? index_esm/* IoAlertCircle */.FXL : getCardIcon((ref3 = (ref = paymentMethod.card) === null || ref === void 0 ? void 0 : ref.brand) !== null && ref3 !== void 0 ? ref3 : "unknown"),
                            w: 8,
                            h: 8
                        }),
                        (ref1 = paymentMethod.card) === null || ref1 === void 0 ? void 0 : ref1.brand,
                        " card ending in ",
                        (ref2 = paymentMethod.card) === null || ref2 === void 0 ? void 0 : ref2.last4
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
                    gap: 4,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_button_esm/* Button */.zx, {
                        variant: "outline",
                        colorScheme: "red",
                        size: "sm",
                        onClick: onRemovePaymentMethod,
                        isLoading: loading,
                        children: "Remove card"
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CardInput, {
            loading: loading,
            onAddPaymentMethod: onAddPaymentMethod
        })
    });
};
var CardInput = function(param) {
    var loading = param.loading, onAddPaymentMethod = param.onAddPaymentMethod;
    var toast = (0,chakra_ui_toast_esm/* useToast */.pm)();
    var stripe = (0,react_stripe_umd.useStripe)();
    var elements = (0,react_stripe_umd.useElements)();
    var ref = (0,react.useState)(false), isLoading = ref[0], setIsLoading = ref[1];
    var ref1 = (0,react.useState)(false), cardInputValid = ref1[0], setCardInputValid = ref1[1];
    var handleCardSave = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var card, ref, error, paymentMethod;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (stripe) {
                            _ctx.next = 2;
                            break;
                        }
                        throw new Error("`stripe` is undefined when saving card");
                    case 2:
                        if (elements) {
                            _ctx.next = 4;
                            break;
                        }
                        throw new Error("Stripe `elements` is undefined when saving card");
                    case 4:
                        card = elements.getElement(react_stripe_umd.CardElement);
                        if (card) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("card is undefined when saving card");
                    case 7:
                        setIsLoading(true);
                        _ctx.next = 10;
                        return stripe.createPaymentMethod({
                            type: "card",
                            card: card
                        });
                    case 10:
                        ref = _ctx.sent;
                        error = ref.error;
                        paymentMethod = ref.paymentMethod;
                        setIsLoading(false);
                        if (!(!paymentMethod || error)) {
                            _ctx.next = 17;
                            break;
                        }
                        toast({
                            title: "An error occurred",
                            description: error.message ? error.message : "Error creating payment method, please try again",
                            status: "error",
                            isClosable: true
                        });
                        throw new Error(error.message ? error.message : "Error creating payment method");
                    case 17:
                        onAddPaymentMethod(paymentMethod);
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleCardSave() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCardChange = function(event) {
        var complete = event.complete;
        setCardInputValid(complete);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Stack */.Kq, {
        w: "full",
        maxW: "sm",
        m: "auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                border: "1px",
                borderColor: "light-gray",
                borderRadius: "md",
                p: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.CardElement, {
                    onChange: handleCardChange
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_button_esm/* Button */.zx, {
                colorScheme: "light-blue",
                color: "medium-gray",
                size: "sm",
                disabled: !cardInputValid || isLoading || loading,
                isLoading: isLoading || loading,
                onClick: handleCardSave,
                children: "Save card"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                alignSelf: "center",
                opacity: 0.7,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/images/powered-by-stripe.svg",
                    width: 89,
                    height: 20,
                    alt: "Powered by Stripe"
                })
            })
        ]
    });
};


/***/ }),

/***/ 6616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ RecipientSlider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1248);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8527);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(918);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6541);
/* harmony import */ var _slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2442);





var RecipientSlider = function(param) {
    var defaultValue = param.defaultValue;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var recipientCount = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.recipientCount;
    }).recipientCount;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!defaultValue) return;
        dispatch((0,_slice__WEBPACK_IMPORTED_MODULE_3__/* .updateRecipientCount */ .mF)(defaultValue));
    }, [
        defaultValue,
        dispatch
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
        pt: 12,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Slider */ .iR, {
            "aria-label": "Select number of recipients",
            defaultValue: defaultValue ? defaultValue : recipientCount,
            min: 1,
            max: 20,
            onChange: function(value) {
                dispatch((0,_slice__WEBPACK_IMPORTED_MODULE_3__/* .updateRecipientCount */ .mF)(value));
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .SliderTrack */ .Uj, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .SliderFilledTrack */ .Ms, {})
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Tooltip */ .u, {
                    label: "".concat(recipientCount, " Recipient").concat(recipientCount === 1 ? "" : "s"),
                    placement: "top",
                    bgColor: "gray",
                    fontSize: "lg",
                    borderRadius: "md",
                    px: "2",
                    py: "1",
                    isOpen: true,
                    hasArrow: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .SliderThumb */ .gs, {})
                })
            ]
        })
    });
};


/***/ }),

/***/ 8519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ getMonthlyPrice; }
/* harmony export */ });
var getMonthlyPrice = function(billingPeriod, recipientCount, monthlyPrice, yearlyMonthlyPrice) {
    return billingPeriod === "monthly" ? recipientCount * monthlyPrice : recipientCount * yearlyMonthlyPrice;
};


/***/ }),

/***/ 2892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useGetPrices; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _services_joyline__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3762);


var useGetPrices = function() {
    var ref = (0,_services_joyline__WEBPACK_IMPORTED_MODULE_1__/* .useGetPricesQuery */ .Bz)(), prices = ref.data;
    var monthlyPrice = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var ref;
        return (ref = prices === null || prices === void 0 ? void 0 : prices.find(function(price) {
            return price.billingPeriod === "monthly";
        })) === null || ref === void 0 ? void 0 : ref.amount;
    }, [
        prices
    ]);
    var yearlyPrice = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var ref;
        return (ref = prices === null || prices === void 0 ? void 0 : prices.find(function(price) {
            return price.billingPeriod === "yearly";
        })) === null || ref === void 0 ? void 0 : ref.amount;
    }, [
        prices
    ]);
    return {
        monthlyPrice: monthlyPrice !== null && monthlyPrice !== void 0 ? monthlyPrice : 0,
        yearlyPrice: yearlyPrice !== null && yearlyPrice !== void 0 ? yearlyPrice : 0,
        yearlyMonthlyPrice: (yearlyPrice !== null && yearlyPrice !== void 0 ? yearlyPrice : 0) / 12
    };
};


/***/ })

}]);